"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _content = require("./content.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ContentUi = function ContentUi(_ref) {
  var id = _ref.id,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["id", "children"]);

  var inner = typeof children === 'string' ? /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: children
    }
  }) : children;
  return /*#__PURE__*/_react.default.createElement(_content.ContentStyled, {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, _extends({}, props, {
    as: "div"
  }), inner));
};

var _default = ContentUi;
exports.default = _default;